<div class="prim-xp__crown">
  <i class="fa-solid fa-crown"></i>
</div>
<div class="prim-xp__data">
  <div class="prim-xp__num">{{ xp.stars | number }}</div>
  <div class="prim-xp__lbl">{{ 'DASHBOARD.PRIMARY.STARS_LABEL' | translate }}</div>
</div>
<div class="prim-xp__bar" [attr.aria-valuenow]="xp.progress">
  <span [style.width.%]="xp.progress"></span>
</div>
<div class="prim-xp__footer">
  <i class="fa-solid fa-bullseye"></i>
  <span [innerHTML]="'DASHBOARD.PRIMARY.XP_FOOTER' | translate:{ remaining: xp.toNext, level: xp.level + 1 }"></span>
</div>
